import React from 'react'
import {CircularProgress} from "@mui/material";
import useLoadUser from "../../../users/utils/useLoadUser";
import UserCard from "../../../users/card/userInfo/UserCard";

const StatisticsUserSummary = ({userUid}) => {
    const {user, loading} = useLoadUser(userUid)

    if (loading) {
        return <CircularProgress/>
    }

    return <UserCard user={user} headerSize={18} textSize={16}/>

}
export default StatisticsUserSummary
